import Component from '../../../shared/component';

const NO_CAREER_IDEAS_STATUS_NAME = 'no_career_ideas';
const OBJECTIVE_MAX_SELECTION_COUNT = 3;

export default class ObjectiveFields extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$status = this.$element.find('.status');
    this.$objectives = this.$element.find('.objectives');
    this.$objectiveCheckboxes = this.$objectives.find(':checkbox');
    this.$objectiveCheckboxesAndLabels = this.$objectives.find(
      '.form-list-item'
    );

    this.bindEvents();
    this.updateObjectivesVisibility();
    this.updateObjectivesEnabledState();
  }

  bindEvents() {
    this.updateObjectivesVisibility = this.updateObjectivesVisibility.bind(
      this
    );
    this.updateObjectivesEnabledState = this.updateObjectivesEnabledState.bind(
      this
    );

    this.$status.on('change.ObjectiveFields', this.updateObjectivesVisibility);
    this.$objectiveCheckboxes.on(
      'change.ObjectiveFields',
      this.updateObjectivesEnabledState
    );
  }

  unbindEvents() {
    this.$status.off('change.ObjectiveFields', this.updateObjectivesVisibility);
    this.$objectiveCheckboxes.off(
      'change.ObjectiveFields',
      this.updateObjectivesEnabledState
    );
  }

  updateObjectivesVisibility() {
    this.$statusName = this.$status.find(':selected').attr('value');

    this.$objectives.toggle(this.$statusName !== NO_CAREER_IDEAS_STATUS_NAME);
  }

  updateObjectivesEnabledState() {
    const checkedCount = this.$objectiveCheckboxesAndLabels
      .find(':checkbox')
      .filter((_index, item) => item.checked === true).length;
    const mustDisableUncheckedObjectives =
      checkedCount >= OBJECTIVE_MAX_SELECTION_COUNT;

    this.$objectiveCheckboxesAndLabels.each((_index, objective) => {
      const $objective = $(objective);
      const $checkbox = $objective.find(':checkbox');
      const checkboxDisabled =
        mustDisableUncheckedObjectives && !$checkbox[0].checked;

      $objective.toggleClass('form-list-item--disabled', checkboxDisabled);
      $checkbox.attr('disabled', checkboxDisabled);
    });
  }
}
